import React from 'react';
import { get } from 'lodash';
import ParametroItem from '../../components/ParametroItem';
import ParametroItemAnalise from '../../components/ParametroItemAnalise';

const AnaliseDados = ({
  discriminacao,
  dificuldade,
  parametrosGabarito,
  itemData,
  analiseGrupo,
  renderAnaliseAlternativas
}) => {
  const color = [
    {
      name: 'Muito Fácil',
      min_dificuldade: 85,
      max_dificuldade: 100,
      color: '#52CE50'
    },
    {
      name: 'Fácil',
      min_dificuldade: 65,
      max_dificuldade: 85,
      color: '#267ed1'
    },
    {
      name: 'Médio',
      min_dificuldade: 35,
      max_dificuldade: 65,
      color: '#ff8e2e'
    },
    {
      name: 'Difícil',
      min_dificuldade: 15,
      max_dificuldade: 35,
      color: '#aa3f3e'
    },
    {
      name: 'Muito Difícil',
      min_dificuldade: 0,
      max_dificuldade: 15,
      color: '#8470FF'
    }
  ];

  const dificuldadeResult = {
    ...itemData,
    dificuldade: color.filter(
      (d) => d.name === get(itemData, 'dificuldade_name')
    )[0]
  };
  let analiseItem = '';
  let descricao_pedagogica = '';

  if (itemData) {
    const discriminacaoNivel =
      get(itemData, 'nivel_discriminacao') === 'Discriminação muito boa' ||
      get(itemData, 'nivel_discriminacao') === 'Discriminação boa' ||
      get(itemData, 'nivel_discriminacao') === 'Discriminação baixa' ||
      get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
      get(itemData, 'nivel_discriminacao') === 'Não Discrimina';

    const bisserialNivel =
      get(itemData, 'nivel_bisserial') === 'Bisserial muito bom' ||
      get(itemData, 'nivel_bisserial') === 'Bisserial bom' ||
      get(itemData, 'nivel_bisserial') === 'Bisserial baixo' ||
      get(itemData, 'nivel_bisserial') === 'Bisserial muito baixo';

    const sameData =
      (get(itemData, 'dificuldade_name') === 'Fácil' &&
        get(itemData, 'dificuldade_real') === 'Difícil') ||
      get(itemData, 'dificuldade_real') === 'Muito Difícil' ||
      (get(itemData, 'dificuldade_name') === 'Médio' &&
        get(itemData, 'dificuldade_real') === 'Difícil') ||
      get(itemData, 'dificuldade_real') === 'Muito Difícil' ||
      (get(itemData, 'dificuldade_name') === 'Difícil' &&
        get(itemData, 'dificuldade_real') === 'Muito Difícil');

    const dificuldadeModulos =
      (get(itemData, 'dificuldade_name') === 'Fácil' &&
        get(itemData, 'dificuldade_real') === 'Difícil') ||
      (get(itemData, 'dificuldade_name') === 'Médio' &&
        get(itemData, 'dificuldade_real') === 'Difícil');

    const dificuldadeModulo2 =
      (get(itemData, 'dificuldade_name') === 'Fácil' &&
        get(itemData, 'dificuldade_real') === 'Muito Difícil') ||
      (get(itemData, 'dificuldade_name') === 'Médio' &&
        get(itemData, 'dificuldade_real') === 'Muito Difícil') ||
      (get(itemData, 'dificuldade_name') === 'Difícil' &&
        get(itemData, 'dificuldade_real') === 'Muito Difícil');

    const nivelDificil =
      get(itemData, 'dificuldade_name') === 'Difícil' &&
      get(itemData, 'dificuldade_real') === 'Difícil';

    const nivelFacil =
      get(itemData, 'dificuldade_name') === 'Fácil' &&
      get(itemData, 'dificuldade_real') === 'Fácil';

    const dificuldadePresumidaMaior =
      (get(itemData, 'dificuldade_name') === 'Fácil' &&
        get(itemData, 'dificuldade_real') === 'Muito Fácil') ||
      (get(itemData, 'dificuldade_name') === 'Médio' &&
        get(itemData, 'dificuldade_real') === 'Fácil') ||
      get(itemData, 'dificuldade_real') === 'Muito Fácil' ||
      (get(itemData, 'dificuldade_name') === 'Difícil' &&
        get(itemData, 'dificuldade_real') === 'Fácil') ||
      get(itemData, 'dificuldade_real') === 'Muito Fácil' ||
      get(itemData, 'dificuldade_real') === 'Médio';

    // 1
    if (
      (get(itemData, 'dificuldade_name') === 'Fácil' &&
        get(itemData, 'dificuldade_real') === 'Fácil') ||
      (get(itemData, 'dificuldade_name') === 'Médio' &&
        get(itemData, 'dificuldade_real') === 'Médio' &&
        discriminacaoNivel &&
        bisserialNivel)
    ) {
      analiseItem = 'Item adequado';
      descricao_pedagogica =
        'Item avaliou de forma adequada o que se propôs a medir. Assim,  pode-se constatar que houve aquisição  (ou não)  da habilidade questionada à turma.  A depender do desempenho apresentado, deve-se avaliar a necessidade de adequações e suportes pedagógicos.';
    }
    // 2
    else if (
      nivelDificil &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação baixa') &&
      bisserialNivel
    ) {
      analiseItem = 'Item adequado';
      descricao_pedagogica =
        'Item avaliou de forma adequada o que se propôs a medir. Assim,  pode-se constatar que houve aquisição  (ou não)  da habilidade questionada à turma.  A depender do desempenho apresentado, deve-se avaliar a necessidade de adequações e suportes pedagógicos.';
    }
    // 3
    else if (
      nivelDificil &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Não Discrimina') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial muito bom' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial bom')
    ) {
      analiseItem = 'Item adequado';
      descricao_pedagogica =
        'Item avaliou de forma adequada o que se propôs a medir. Assim,  pode-se constatar que houve aquisição  (ou não)  da habilidade questionada à turma.  A depender do desempenho apresentado, deve-se avaliar a necessidade de adequações e suportes pedagógicos.';
    }
    //4
    else if (
      nivelDificil &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Não Discrimina') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial baixo' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial muito baixo')
    ) {
      analiseItem = 'Item com inadequações';
      descricao_pedagogica =
        'Parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
    }
    // 5
    else if (
      get(itemData, 'dificuldade_name') !== get(itemData, 'dificuldade_real') &&
      dificuldadePresumidaMaior &&
      get(dificuldadeResult, 'dificuldade.max_dificuldade') <=
      get(itemData, 'acertos') &&
      bisserialNivel &&
      discriminacaoNivel
    ) {
      analiseItem = 'Item adequado com ponderações';
      descricao_pedagogica =
        'O item apresentou dificuldade menor que o presumido. Deve-se avaliar se: a) os distratores foram pouco plausíveis: neste caso deve-se rever a construção dos distratores deixando-os mais próximos da resposta correta; e/ou  b) o gabarito apresentou um atrativo que não deixou dúvidas em relação à resposta correta: neste  caso rever a construção do gabarito; ou  c) o conteúdo foi bem assimilado e por isso o item teve nível de dificulade menor que o esperado: caso deseje aumentar a dificulade do item pode-se contextualizá-lo e/ou abordar níveis mais altos de habilidade descritos na  Taxonomia de Bloom.';
    }
    //6
    else if (
      get(itemData, 'dificuldade_name') === 'Fácil' &&
      get(itemData, 'dificuldade_real') === 'Médio' &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      bisserialNivel &&
      discriminacaoNivel
    ) {
      analiseItem = 'Item adequado com ponderações';
      descricao_pedagogica =
        'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
    }
    // 7 - 1 modulo
    else if (
      dificuldadeModulos &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      bisserialNivel &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação baixa')
    ) {
      analiseItem = 'Item adequado com ponderações';
      descricao_pedagogica =
        'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
    }
    // 7 - 2 modulo
    else if (
      dificuldadeModulo2 &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial muito bom' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial bom' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial baixo') &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação baixa')
    ) {
      analiseItem = 'Item adequado com ponderações';
      descricao_pedagogica =
        'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
    }
    // 8
    else if (
      sameData &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial muito bom' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial bom') &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Não Discrimina')
    ) {
      analiseItem = 'Item adequado com ponderações';
      descricao_pedagogica =
        'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
    }
    // 9 - 1 modulo
    else if (
      dificuldadeModulos &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial baixo' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial muito baixo') &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Não Discrimina')
    ) {
      analiseItem = 'Item com inadequações';
      descricao_pedagogica =
        'O item teve dificuldade maior do que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Além disso,  pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
    }
    // 9 - 2 modulo
    else if (
      dificuldadeModulo2 &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial baixo' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial muito baixo') &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Não Discrimina')
    ) {
      analiseItem = 'Incompátivel';
      descricao_pedagogica =
        'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item. ';
    }
    // 10
    else if (
      dificuldadePresumidaMaior &&
      get(dificuldadeResult, 'dificuldade.max_dificuldade') <
      get(itemData, 'acertos') &&
      discriminacaoNivel &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado')
    ) {
      analiseItem = 'Item com inadequações';
      descricao_pedagogica =
        'O item apresentou dificuldade menor que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c)se o gabarito foi marcado errado.';
    }
    // 11
    else if (
      nivelFacil &&
      discriminacaoNivel &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado')
    ) {
      analiseItem = 'Item com inadequações';
      descricao_pedagogica =
        'Parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou  b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c) se o gabarito foi marcado errado.';
    }
    // 12
    else if (
      get(itemData, 'dificuldade_name') === get(itemData, 'dificuldade_real') &&
      nivelDificil &&
      discriminacaoNivel &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado')
    ) {
      analiseItem = 'Item incompatível';
      descricao_pedagogica =
        'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
    }
    // 13
    else if (
      sameData &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      discriminacaoNivel &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado')
    ) {
      analiseItem = 'Item incompatível';
      descricao_pedagogica =
        'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
    }
    // 14
    else if (
      get(itemData, 'dificuldade_name') === 'Médio' &&
      get(itemData, 'dificuldade_real') === 'Médio' &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação muito boa') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado')
    ) {
      analiseItem = 'Item com inadequações';
      descricao_pedagogica =
        'Parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou  b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c) se o gabarito foi marcado errado.';
    }
    // 15
    else if (
      get(itemData, 'dificuldade_name') === get(itemData, 'dificuldade_real') &&
      get(itemData, 'dificuldade_name') === 'Médio' &&
      get(itemData, 'dificuldade_real') === 'Médio' &&
      (get(itemData, 'nivel_discriminacao') === 'Não Discrimina' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado')
    ) {
      analiseItem = 'Item incompatível';
      descricao_pedagogica =
        'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
    }
    // 16
    if (
      get(itemData, 'dificuldade_name') === 'Difícil' &&
      get(itemData, 'dificuldade_real') === 'Médio' &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado') &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação muito boa')
    ) {
      analiseItem = 'Item com inadequações';
      descricao_pedagogica =
        'O item apresentou dificuldade menor que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c)se o gabarito foi marcado errado.';
    }
    // 17
    else if (
      get(itemData, 'dificuldade_name') === 'Difícil' &&
      get(itemData, 'dificuldade_real') === 'Médio' &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado') &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação baixa' ||
        get(itemData, 'nivel_discriminacao') === 'Não Discrimina')
    ) {
      analiseItem = 'Item incompatível';
      descricao_pedagogica =
        'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item. ';
    }
    // 18
    if (
      get(itemData, 'dificuldade_name') === 'Fácil' &&
      get(itemData, 'dificuldade_real') === 'Médio' &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
      get(itemData, 'acertos') <=
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado') &&
      (get(itemData, 'nivel_discriminacao') === 'Discriminação muito boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação baixa')
    ) {
      analiseItem = 'Item com inadequações';
      descricao_pedagogica =
        'O item teve dificuldade maior do que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Além disso,  pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
    }
    // 19
    else if (
      get(itemData, 'dificuldade_name') === 'Fácil' &&
      get(itemData, 'dificuldade_real') === 'Médio' &&
      get(dificuldadeResult, 'dificuldade.min_dificuldade') >
      get(itemData, 'acertos') <
      get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
      (get(itemData, 'nivel_bisserial') === 'Bisserial inapropriado' ||
        get(itemData, 'nivel_bisserial') === 'Bisserial inadequado') &&
      (get(itemData, 'nivel_discriminacao') === 'Não Discrimina' ||
        get(itemData, 'nivel_discriminacao') === 'Discriminação muito baixa')
    ) {
      analiseItem = 'Item incompatível';
      descricao_pedagogica =
        'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
    }
  }

  return (
    <div className="pt-3 container">
      <div className="d-flex row pt-4 mt-4 mb-4 pb-4">
        <div className="col-12 pb-3">
          <p className="azul">
            <b>Análise do item</b>
          </p>
        </div>
        <ParametroItem
          col="col-3"
          name="Dificuldade"
          title="Dificuldade Presumida"
          color={get(dificuldadeResult, 'dificuldade.color')}
          label={get(itemData, 'dificuldade_name')}
        />
        <ParametroItem
          col="col-3"
          name="Dificuldade"
          title="Dificuldade Mensurada"
          value={dificuldade}
          color={get(parametrosGabarito, 'cor_dificuldade')}
          label={get(parametrosGabarito, 'nivel_dificuldade')}
        />
        <ParametroItem
          col="col-3"
          name="Dificuldade"
          title="Índice de discriminacao"
          value={discriminacao}
          color={get(parametrosGabarito, 'cor_discriminacao')}
          label={get(parametrosGabarito, 'nivel_discriminacao')}
        />
        <ParametroItemAnalise
          col="col-3"
          name="Classificacao"
          title="Classificação"
          label={analiseItem}
        />
      </div>
      <hr className="hr-analise" />
      <div>
        {analiseGrupo}
        <span className="span-analise">
          <strong>Grupos:</strong> os alunos, a depender do desempenho na prova
          como um todo, são alocados em grupos, sendo que o grupo 1 - de mais
          baixo desempenho e o grupo 5 - de mais alto desempenho.
        </span>
      </div>
      <hr className="hr-analise" />

      {renderAnaliseAlternativas}

      <hr className="hr-analise" />
      <div className="col-12 pb-3">
        <p className="azul">
          <b>Análise pedagógica</b>
        </p>
        <span className="span-analise" style={{ textAlign: 'justify' }}>
          {descricao_pedagogica}
        </span>
      </div>
    </div>
  );
};

export default AnaliseDados;
